(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminWebhookEditSettingsController', AdminWebhookEditSettingsController);

    function AdminWebhookEditSettingsController(
        $controller,
        $state,
        $scope,
        $translate,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        siteAssociateTypesCollection,
        assetScoreTypesCollection,
        recurrenceRulesService,
        elogsUserCollection,
        contractManager,
        elbSettings,
        module,
        modulesService,
        meridianConfigurationCollectionResponse,
        confirmationModal,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            $scope: $scope,
            $translate: $translate,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'webhook_job',
                ...(modulesService.isEnabled('quotes') ? ['webhook_quote'] : [])
            ],
            siteAssociateTypesCollection: siteAssociateTypesCollection,
            assetScoreTypesCollection: assetScoreTypesCollection,
            recurrenceRulesService: recurrenceRulesService,
            elogsUserCollection: elogsUserCollection,
            contractManager: contractManager,
            elbSettings: elbSettings,
            module: module,
            modulesService: modulesService,
            meridianConfigurationCollectionResponse: meridianConfigurationCollectionResponse,
            confirmationModal: confirmationModal,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'webhook_job' : { type : 'checkbox' },
                ...(modulesService.isEnabled('quotes') ? { 'webhook_quote': { type: 'checkbox' } } : {})
            })
        });
        angular.extend(vm, base);
    }
})();
